import { httpsCallable } from "firebase/functions";
import { functions } from "../utils/Firebase-Config";

export const createMvelioSubscription = async (priceId, tierName, user) => {
  if (!user) {
    alert("You must create an account first to choose a subscription.");
    return;
  }

  try {
    const fn = httpsCallable(functions, "createMvelioSubscriptionSession");
    const result = await fn({ priceId, tierName }); // Passes tierName payload
    
    if (result.data?.url) {
      window.location.assign(result.data.url);
    } else {
      throw new Error("No checkout URL was returned from the server.");
    }
  } catch (err) {
    console.error("Mvelio Stripe Subscription Checkout Failed:", err);
    alert("Unable to start subscription setup: " + err.message);
  }
};



